import uuidv4 from 'uuid/v4'

const COOKIE_EXPIRATION_DAYS = 30 // eslint-disable-line no-unused-vars
const PREFIX_GUEST = 'GUEST-'
const PREFIX_USER = 'USER-'
const cookie = require('vue-cookie')

class WidgetSession {

  /**
   * Constructor
   * Receive the main Vue app where we can find the cookie plugin
   */
  constructor (VueApp) {
    this.vueApp = VueApp
    this.cookie = this.vueApp.$cookie
    this._token = cookie.get('userToken')
  }

  /**
   * Initialize
   * During start of an application generates a new guest token if it doesnt exist yet
   */
  initializeToken () {
    if (!this._token) {
      this.generateGuestToken()
    }
  }

  /**
   * .generateGuestToken()
   * Generate a new guest token and save it
   */
  generateGuestToken (save = true) {
    return this.generateToken(PREFIX_GUEST, save)
  }

  /**
   * .generateUserToken()
   * Generate a new user token and save it
   */
  generateUserToken (save = true) {
    return this.generateToken(PREFIX_USER, save)
  }

  /**
   * this.generateToken()
   * Common behavior of generating tokens of all types
   * Used only on this class (private)
   */
  generateToken (prefix, save) {
    let newToken = prefix + uuidv4()
    this._token = newToken
    return newToken
  }

  /**
   * .useToken()
   * Save a token generated from external sources
   */
  useToken (token) {
    this._token = token
    cookie.set('userToken', token, 30) // expire in 30 days
  }

  /**
   * .hasAuthenticatedUser()
   * Identifies if the currently saved token has a logged-in user associated with it
   */
  hasAuthenticatedUser () {
    return this.token.indexOf(PREFIX_GUEST) === -1
  }

  /**
   * .isGuestToken()
   * Identifies if the passed token has is for a guest or a registered user
   */
  isGuestToken (token) {
    return token.indexOf(PREFIX_GUEST) === 0
  }

  /**
   * .token
   * Returns the current token and generates if it doesn't exist
   */
  get token () {
    return this._token || this.generateGuestToken()
  }

  /**
   * .destroy()
   * Deletes the current token and generates a new one
   */
  destroy () {
    this._token = null
    return this.generateGuestToken()
  }

}

export default WidgetSession



// WEBPACK FOOTER //
// ./src/modules/session.js